import React from 'react';
import {CurricularClass82023}  from 'views/CurricularClass52023/components';

const ExtraCurricularActivitiesPage = () => {
  return <CurricularClass82023 />;
};

export default ExtraCurricularActivitiesPage;
